/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { badResponseModelSchema } from "../badResponseModelSchema.ts";
import { trackModelSchema } from "../trackModelSchema.ts";
import { z } from "zod";

export const getApiTracksIdPathParamsSchema = z.object({
    "Id": z.string().uuid().describe("Идентификатор трека")
    })

/**
 * @description Модель трека
 */
export const getApiTracksId200Schema = z.lazy(() => trackModelSchema)

/**
 * @description Ошибка валидации запроса | Неправильный запрос
 */
export const getApiTracksId400Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Пользователь не авторизован
 */
export const getApiTracksId401Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Недостаточно прав для выполнения запроса
 */
export const getApiTracksId403Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Трек не найден
 */
export const getApiTracksId404Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Внутренняя ошибка сервера
 */
export const getApiTracksId500Schema = z.lazy(() => badResponseModelSchema)

export const getApiTracksIdQueryResponseSchema = z.lazy(() => getApiTracksId200Schema)